import { ComicPageLoader } from "@vapor/react-contrib-tax-compliance";
import type { ReactElement, ReactNode } from "react";
import { usePermissionsContext } from "./PermissionsContext";

interface PermissionsGateProps {
    children: ReactNode;
}

/** The app's single loader while the policies are being evaluated. */
export const PermissionsGate = ({
    children,
}: PermissionsGateProps): ReactElement => {
    const { isLoading } = usePermissionsContext();
    return <ComicPageLoader loading={isLoading}>{children}</ComicPageLoader>;
};
